import { ResponseMessagesEnum } from "../../interfaces/Enums";
import { IFormData } from "../../pages/public/SignUp/validation";
import { api } from "../../services/api";
import { useAlertError } from "../../store/AlertError";
import { useGlobalLoading } from "../../store/GlobalLoading";
import { useAuthLogin } from "./login";

export function useAuthCreate() {
  const { openAlert } = useAlertError();
  const { closeLoading } = useGlobalLoading();
  const { request } = useAuthLogin();

  async function createUser(body: IFormData): Promise<any> {
    try {
      await api.post("/authentication/signup", body);
      request({
        email: body.email,
        password: body.password,
      });
    } catch {
      handleError();
      closeLoading();
    }
  }

  function handleError(): void {
    openAlert({
      message: ResponseMessagesEnum.ErrorCreateUser,
      status: "error",
    });
  }

  return { createUser };
}
